import React, { Component } from "react";
import {
  CircularProgress,
  TextField,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  DialogActions,
  Dialog,
} from "@material-ui/core";
import { Translation } from "react-i18next";
import { MenuItem } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import InputAdornment from "@material-ui/core/InputAdornment";
import { FaWpforms } from "react-icons/fa";
import CreateAddClearance from "../../../_clearance/utils/CreateAddClearance";
// import trackFields from "../../../_module/definition/trackFields";
import { PlaylistItemTypes } from "./RecentPlaylistMenu";
import clsx from "clsx";
import { CFOrgStatus } from "../../../redux/Types";
import { v4 as uuidv4 } from "uuid";

class RecentCFMenu extends Component {
  constructor(props) {
    super();
    this.state = {
      messageOpen: false,
      rList: null,
    };
  }
  input = null;

  filterChangeTimer = null;

  componentWillUnmount() {
    const { loadRecent, setRecentQuery, recentQuery, recentList } = this.props;
    if (recentQuery.q !== "") {
      setRecentQuery("");
      loadRecent({ ...recentQuery, q: "" });
    }
  }

  reloadRecentList(){
    const { loadRecent, recentQuery } = this.props;
    loadRecent({ ...recentQuery, q: recentQuery.q });
  }

  onFilterChange = (e) => {
    const { loadRecent, setRecentQuery, recentQuery } = this.props;
    var filter = e.currentTarget.value;
    setRecentQuery(filter);
    clearTimeout(this.filterChangeTimer);
    this.filterChangeTimer = setTimeout(() => {
      loadRecent({ ...recentQuery, q: filter });
    }, 400);
  };

  onConfirm = (e, cf) => {
    const { user, items, tracks, setCFTracks, handleClose, showMessage, removeHistory, removeTrackSearchkHistory, removeTrackSearchkHistoryAll ,
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
      
        }
      } 
    } =
      this.props;
    handleClose(e);
    if (tracks?.length > 0 && cf && cf.id) {
      showMessage(`Adding track(s) to Clearance "${cf.name}"`);
      let confirmed = [];

      const trackIds = [];
      const cleanedTracks = [];
      const filteredTracks = items?.filter(
        (r) => !r.pl_prop_type || r.pl_prop_type === PlaylistItemTypes.track
      );
      if (filteredTracks) {
        filteredTracks.forEach((t) => {
          let sequenceId = uuidv4();
          if (tracks?.includes(t.id)) {
            trackIds.push(sequenceId);
          }
          const trackCopy = JSON.parse(JSON.stringify(t));
          trackCopy.pl_prop_id = undefined;
          trackCopy.pl_prop_type = undefined;
          trackCopy.pl_prop_position = undefined;
          trackCopy.pl_prop_notes = undefined;
          trackCopy.pl_prop_tags = undefined;
          trackCopy.highlights = undefined;
          trackCopy.skyMlId = t.id;
          trackCopy.id = sequenceId;

          cleanedTracks.push(trackCopy);
        });
      }

      let tracksAlreadyExist = true;
      for(let i=0;i<trackIds.length;i++){
        if(cf.clearance.tracks.indexOf(trackIds[i]) == -1){
          tracksAlreadyExist = false;
          break;
        }
      }

      if(tracksAlreadyExist){
        showMessage(`Track(s) already exist`);
        setTimeout(()=>{
          showMessage();
        }, 1000)
        return;
      }
      
      trackIds.map((v) => {
        let trackDetails = cleanedTracks.filter((d) => d.id == v)[0];
        if (trackDetails) {
          delete trackDetails['score'];
          delete trackDetails['scoreExp'];
          confirmed.push({
            trackDetails: trackDetails,
            origin: trackDetails[trackFields.musicOrigin.id],
            clearancestatus: 0,
            messageid: null,
            by: user.id,
            at: new Date().toISOString(),
            adminOverridden: 0,
            trackNotes: "",
          });
        }
      });
      setCFTracks(
        "addtracks",
        null,
        { cf: cf.id, tracks: trackIds, confirmed: confirmed },
        (data, error) => {
          if (error) {
            showMessage(error);
          } else {
            cf.tracksCount = data.count || 0;
            showMessage();
            this.reloadRecentList();
            removeHistory(cf.id);
            removeTrackSearchkHistoryAll();
          }
        }
      );
    }
  };

  handleMessageConfirm = (e) => {
    const { rList } = this.state;
    this.onConfirm(e, rList);
    this.setState({ messageOpen: false });
  };

  handeConfirmMessageOpen = (rList) => {
    this.setState({ messageOpen: true, rList: rList });
  };

  handleCloseMessage = () => {
    this.setState({ messageOpen: false });
    const { handleClose } = this.props;
    handleClose();
  };

  render() {
    const { user, classes, busy, recentList, recentQuery, tracks, disableMenu } = this.props;
    const { messageOpen } = this.state;

    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            <Dialog
              open={messageOpen}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              className={classes.dialogWrapper}
              class="dialogBox"
            >
              <DialogTitle id="alert-dialog-title">
                {"Confirmation Alert"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {" "}
                  {"Are you sure, you want to add to clearance?"}{" "}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  className={classes.dialogYesButton}
                  onClick={(e) => {
                    this.handleMessageConfirm(e);
                  }}
                  color="primary"
                  autoFocus
                >
                  Yes
                </Button>
                <Button
                  className={classes.dialogNoButton}
                  onClick={this.handleCloseMessage}
                  color="primary"
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>
            {/* <CreateAddClearance {...this.props} /> */}
            <div style={{margin: "10px 0px 5px 0px"}} className={classes.addtoClearance}>Add to Clearance</div>
            <div style={{marginTop: "5px"}} title="Recently Viewed">
              { user?.recentlyViewed && user?.recentlyViewed?.clearanceForms && (
                <>
                  {!busy &&
                    Array.isArray(user.recentlyViewed.clearanceForms) &&
                    user.recentlyViewed.clearanceForms?.slice(0, 1).map((r, index) => {
                      return (
                        <MenuItem
                          key={index}
                          className={classes.recentClearanceItems}
                          tabIndex={0}
                          disabled={
                            disableMenu || !tracks || tracks?.length === 0 || r.status == CFOrgStatus.SUBMITTED || r.status == CFOrgStatus.COMPLETED || busy ? true : false
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            // this.onConfirm(e, r);
                            this.handeConfirmMessageOpen(r);
                          }}
                        >
                        {r.master ? 
                          <span title="Series Master " className="seriesIndicator recentList">S</span>
                        :
                          <FaWpforms
                            title="Playlists"
                            style={{ fontSize: "15px" }}
                            className={classes.newClearanceIcons}
                          />
                        }
                          {" "}
                          {r.name} ({r.tracksCount})
                        </MenuItem>
                      );
                    })}
                </>
              ) }
            </div>
          
            <MenuItem className={clsx(classes.disableHover)}  tabIndex={0} onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (this.input) {
                      this.input.focus();
                    }
                  }} disableRipple>
            <div
            id="add-to-clearance"
            aria-label="Search clearance"
              onClickCapture={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              onKeyDown={(e) => e.stopPropagation()}
            >
              <TextField
                autoComplete="off"
                name="recentcf"
                variant="outlined"
                type="text"
                placeholder={"Search clearance"}
                inputRef={(input) => (this.input = input)}
                inputProps={{
                  "aria-label": "Search clearance",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <FiSearch />
                    </InputAdornment>
                  ),
                }}
                className={classes.recentClearanceSearch}
                value={recentQuery.q}
                onChange={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.onFilterChange(e);
                }}
                disabled={disableMenu}
              />
            </div>
            </MenuItem>

            {busy && <CircularProgress className={classes.circularProgress} />}
            {!busy && (!recentList || !recentList.length) && (
              <span class="noDataToPreview">Nothing to list </span>
            )}

            {!busy &&
              Array.isArray(recentList) &&
              recentList?.map((r, index) => {
                return (
                  <MenuItem
                    key={index}
                    id={`clearance-item-${index}`}
                    className={classes.recentClearanceItems}
                    tabIndex={0}
                    disabled={
                      disableMenu || !tracks || tracks?.length === 0 || r.status == CFOrgStatus.SUBMITTED || r.status == CFOrgStatus.COMPLETED || busy ? true : false
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      // this.onConfirm(e, r);
                      this.handeConfirmMessageOpen(r);
                    }}
                  >
                  {r.master ? 
                    <span title="Series Master " className="seriesIndicator recentList">S</span>
                  :
                    <FaWpforms
                      title="Playlists"
                      style={{ fontSize: "15px" }}
                      className={classes.newClearanceIcons}
                    />
                  }
                    {" "}
                    {r.name} ({r.tracksCount})
                  </MenuItem>
                );
              })}
          </>
        )}
      </Translation>
    );
  }
}

export default withRouter(RecentCFMenu);
